(function () {
  var wrapper = document.querySelector('.ccg-wrapper');
  if (!wrapper) return;

  /* ---- filter panel toggle ---- */
  var toggleBtn = document.getElementById('ccg-filter-toggle');
  var panel = document.getElementById('ccg-filter-panel');
  if (toggleBtn && panel) {
    toggleBtn.addEventListener('click', function () {
      var isOpen = !panel.hidden;
      panel.hidden = isOpen;
      toggleBtn.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  /* ---- sort ---- */
  var sortSelect = document.getElementById('ccg-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var basePath = sortSelect.getAttribute('data-collection-url') || window.location.pathname;
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', sortSelect.value);
      params.delete('page'); // نرجعو لصفحة 1

      var finalUrl = basePath + '?' + params.toString();

      // نفرضو reload حقيقي من السيرفر، بلا أي cache محلي
      window.location.replace(finalUrl);
    });
  }

  /* ---- toast ---- */
  var toast = document.createElement('div');
  toast.className = 'ccg-toast';
  toast.innerHTML =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>' +
    '<span class="ccg-toast-text"></span>';
  document.body.appendChild(toast);
  var toastTimer;
  function showToast(message, isError) {
    toast.querySelector('.ccg-toast-text').textContent = message;
    toast.classList.toggle('is-error', !!isError);
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  /* ---- add to cart ---- */
  wrapper.addEventListener('click', function (e) {
    var btn = e.target.closest('.ccg-add-btn');
    if (!btn) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.classList.add('is-loading');

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        showToast('Product added to cart');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (err) {
        showToast((err && err.description) || 'Error, product unavailable', true);
      })
      .finally(function () {
        btn.classList.remove('is-loading');
      });
  });
})();